import { OtsStaffOrderStatus } from '../types';

const OTS_STAFF_IMAGE_ROOT = '/assets/images/ots/staff';

export const OTS_STAFF_STATUS_ICON_SRC: Record<OtsStaffOrderStatus, string> = {
  new: `${OTS_STAFF_IMAGE_ROOT}/bell.svg`,
  preparing: `${OTS_STAFF_IMAGE_ROOT}/preparing.svg`,
  ready: `${OTS_STAFF_IMAGE_ROOT}/ready.svg`,
  done: `${OTS_STAFF_IMAGE_ROOT}/done.svg`
};

export const OTS_STAFF_DELIVERY_ICON_SRC = `${OTS_STAFF_IMAGE_ROOT}/location-delivery.svg`;

export const OTS_STAFF_PICKUP_ICON_SRC = `${OTS_STAFF_IMAGE_ROOT}/pin.svg`;
